// Legacy re-export. New code should import from mediaConfig.
export { BRAND, CLIENT_LOGOS_CONFIG } from "@/lib/mediaConfig";
import { CLIENT_LOGOS_CONFIG, MEDIA } from "@/lib/mediaConfig";

export const CLIENT_LOGOS_ROW1 = CLIENT_LOGOS_CONFIG.row1;
export const CLIENT_LOGOS_ROW2 = CLIENT_LOGOS_CONFIG.row2;

// Backwards compat: expose first image of each block as a plain URL.
export const SCREENSHOTS = {
  dashboard: MEDIA.features.dashboard.images[0],
  products: MEDIA.features.products.images[0],
  clients: MEDIA.features.manual.images[0],
  singlePayments: MEDIA.features.checkout.images[0],
  recurring: MEDIA.features.recurring.images[0],
  transactions: MEDIA.features.retry.images[0],
  settings: MEDIA.features.acquirers.images[0],
};
